import host from './host.js';
import request from '../utils/request.js';
import qs from 'qs';

const product = {
    productList(params)
    { //查询首页商品
        let marketActObj = JSON.parse(localStorage.getItem('marketActObj'))
        if (marketActObj) params.marketId = marketActObj.id
        return request.post( host.test + '/Kitchen/ShopGoods/GetCategoryShopGoodList', params );
    },
    productType()
    { //获取产品分类
        return request.post( host.test + '/Kitchen/ProductCategory/ProductCategoryTree' );
    },
    ProductCategoryTree()
    {
        return request.post( host.test + '/Kitchen/ProductCategory/AllProductCategoryTree' );
    },
    goodsList( params )
    { //商品列表
        let marketActObj = JSON.parse(localStorage.getItem('marketActObj'))
        if (marketActObj) params.Params['marketId'] = marketActObj.id
        return request.post( host.test + '/Kitchen/ShopGoods/GetShopGoodList', params );
    },
    clickSave( params )
    { //点击关注
        return request.post( host.test + '/Kitchen/ShopGoods/AddUserAttentionProduct', params );
    },
    clickcancel( params )
    { //点击取消关注
        return request.post( host.test + '/Kitchen/ShopGoods/DelUserAttentionProduct/' + params );
    },
    saveList( params )
    { //我的关注列表数据
        return request.post( host.test + '/Kitchen/ShopGoods/GetUserAttentionProduct', params );
    },
    joinshopCart( params )
    { //加入购物车
        return request.post( host.test + '/Kitchen/ShopGoods/AddUserShoppingCar', params );
    },
    shopcartList( params )
    { //购物车数据
        let marketActObj = JSON.parse(localStorage.getItem('marketActObj'))
        params['Vegetable_MarketID'] = marketActObj.id
        return request.post( host.test + '/Kitchen/ShopGoods/GetUserShoppingCarList', params );
    },
    updatecartNum( params )
    { //修改购物车数量
        return request.post( host.test + '/Kitchen/ShopGoods/EditUserShoppingCar', params );
    },
    goodsDetail( params )
    { //详情页数据
        return request.post( host.test + '/Kitchen/ShopGoods/GetShopGood/' + params );
    },
    GetJiFenGood( params )
    { //积分详情页
        return request.post( host.test + '/Kitchen/ShopGoods/GetJiFenGood/' + params );
    },
    GetUserGeneralVolumeLog( params )
    {
        return request.post( host.test + '/Kitchen/Balances/GetUserGeneralVolumeLog', params );
    },
    deleteGoods( params )
    { //购物车删除商品
        return request.post( host.test + '/Kitchen/ShopGoods/DelUserShoppingCar', params );
    },
    getindexBanner( params )
    { //获取首页轮播图
        return request.post( host.test + '/Kitchen/Banner/GetBannerList', params );
    },
    MMCProductCategoryTree( params )
    {
        return request.post( host.test + '/Kitchen/ProductCategory/MMCProductCategoryTree', params );
    },
    BDXCProductCategoryTree( params )
    {
        return request.post( host.test + '/Kitchen/ProductCategory/BDXCProductCategoryTree', params );
    },
    GetMMCCategoryShopGoodList( params )
    {
        return request.post( host.test + '/Kitchen/ShopGoods/GetMMCCategoryShopGoodList', params );
    },
    GetBDXCCategoryShopGoodList( params )
    {
        return request.post( host.test + '/Kitchen/ShopGoods/GetBDXCCategoryShopGoodList', params );
    },
    GetMMCShopGoodList( params )
    {
        return request.post( host.test + '/Kitchen/ShopGoods/GetMMCShopGoodList', params );
    },
    GetBDXCShopGoodList( params )
    {
        return request.post( host.test + '/Kitchen/ShopGoods/GetBDXCShopGoodList', params );
    },
    GetMMCGood( id )
    {
        return request.post( host.test + '/Kitchen/ShopGoods/GetMMCGood/' + id, '' );
    },
    GetBDXCGood( id )
    {
        return request.post( host.test + '/Kitchen/ShopGoods/GetBDXCGood/' + id, '' );
    },
    GetMMCShopGoodList2( params )
    {
        return request.post( host.test + '/Kitchen/ShopGoods/GetMMCShopGoodList', params );
    },
    





    
    GetUserBalanceLog( params )
    {
        return request.post( host.test + '/Kitchen/Balances/GetUserBalanceLog', params );
    },
    GetUserBankList(params)
    {
        return request.post( host.test + '/Kitchen/KitchenUser/GetUserBankList', params );
    },
    VerifyPayPwd(params)
    {
        return request.post( host.test + '/Kitchen/KitchenUser/VerifyPayPwd', params );
    },
    CancelOrder(id)
    {
        return request.post( host.test + '/Kitchen/Order/CancelOrder/' + id );
    },
    ConfirmReceipt(id)
    {
        return request.post( host.test + '/Kitchen/Order/ConfirmReceipt/' + id );
    },
    UserCashOut(params)
    {
        return request.post( host.test + '/Kitchen/Order/UserCashOut', params );
    },
    GetUserReflectLog(params)
    {
        return request.post( host.test + '/Kitchen/Balances/GetUserReflectLog', params );
    },
    GetVipInfoByVipNo(params)
    {
        return request.post( host.test + '/Kitchen/Order/GetVipInfoByVipNo', params );
    },
    UserTokenMoneyTrade(params)
    {
        return request.post( host.test + '/Kitchen/Order/UserTokenMoneyTrade', params );
    },
    IntegralConfirmReceipt(id)
    {
        return request.post( host.test + '/Kitchen/Order/IntegralConfirmReceipt/'+ id );
    },
    IntegralCancelOrder(id)
    {
        return request.post( host.test + '/Kitchen/Order/IntegralCancelOrder/'+ id );
    },
    GetUserTokenMoneyTrading(params)
    {
        return request.post( host.test + '/Kitchen/Balances/GetUserTokenMoneyTrading', params );
    },
    UserTKMToBalTrade(params)
    {
        return request.post( host.test + '/Kitchen/Balances/UserTKMToBalTrade', params );
    },
    GetUserTkmtobalList(params)
    {
        return request.post( host.test + '/Kitchen/Balances/GetUserTkmtobalList', params );
    },
    GetDiscountShopGoodList( param )
    {
        return request(
        {
            url: host.test + "/Kitchen/ShopGoods/GetDiscountShopGoodList",
            method: "post",
            data: param
        } )
    }
}

export default product;